module.exports = __webpack_public_path__ + "img/icon-search.773424d1.svg";